import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getOffersHistorySpoiler } from '../../../actions/offersHistory';
import { ESpoilerCategoryRequest } from '../../../types/offerHistory';
import { trackCategoryClick } from '../Desktop/analytics';
import { TThunkDispatch } from '../../../types/redux';

export const useActiveCategory = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const [selectedCategory, setSelectedCategory] = useState<ESpoilerCategoryRequest>();

  const updateActiveCategory = useCallback(
    (category: ESpoilerCategoryRequest) => {
      if (selectedCategory === category) {
        return;
      }

      trackCategoryClick(category);

      setSelectedCategory(category);

      dispatch(getOffersHistorySpoiler(category));
    },
    [dispatch, selectedCategory],
  );

  return [selectedCategory, updateActiveCategory] as const;
};
